import { Box, Flex } from '@chakra-ui/react';
import { useLivestreamMessage } from '@lib/firebase';
import { motion } from 'framer-motion';
import { FunctionComponent } from 'react';

const MotionFlex = motion(Flex);

const LiveMessage: FunctionComponent<{ eventId: string }> = ({ eventId }) => {
    const [message] = useLivestreamMessage(eventId);
    if (message) {
        return (
            <MotionFlex
                initial={{ y: 100, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: 100, opacity: 0 }}
                align={message && message.full_cover ? 'stretch' : 'flex-end'}
                justify="center"
                pos="absolute"
                zIndex={10}
                w="full"
                height="full"
                pointerEvents="none">
                <Box
                    pointerEvents="auto"
                    className="livestream-message"
                    p="4"
                    boxShadow="lg"
                    borderRadius={message && message.full_cover ? '0' : 'lg'}
                    bg="highlight"
                    color="highlightText"
                    minW="280px"
                    maxW={message && message.full_cover ? '100%' : '880px'}
                    w={message && message.full_cover ? '100%' : '90%'}
                    mb={!message || !message.full_cover ? '55px' : 0}
                    dangerouslySetInnerHTML={{ __html: message.content }}
                />
            </MotionFlex>
        );
    }
    return null;
};

export default LiveMessage;
